import React from "react";
import Select from 'react-select';

const CustomReactSelect = (props) => {

    let defaultOptions = {
        noOptionsMessage: () => gettext('No options'),
        loadingMessage: () => gettext('Loading...'),
        placeholder: gettext('Select...'),
        className: "react-select",
        classNamePrefix: "react-select",
    }
    
    const options = Object.assign(defaultOptions, props)

    return <Select {...options} />
}

export default CustomReactSelect